import { Suspense } from 'react';
import LoadingScreen from '~/components/loaders/LoadingScreen';
import { Outlet } from 'react-router-dom';
import queryString from 'query-string';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorBoundaryFallback } from '~/components/errors/ErrorBoundaryFallback';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { QueryParamProvider } from 'use-query-params';
import { ModalProvider } from '~/components/modals/Modal';
import { Slide, ToastContainer } from 'react-toastify';

const AppRoot: React.FC<{}> = () => (
  <QueryParamProvider
    adapter={ReactRouter6Adapter}
    options={{
      searchStringToObject: queryString.parse,
      objectToSearchString: queryString.stringify,
      enableBatching: true,
    }}
  >
    <ModalProvider>
      <Suspense fallback={<LoadingScreen />}>
        <ErrorBoundary fallbackRender={ErrorBoundaryFallback}>
          <Outlet />
        </ErrorBoundary>
      </Suspense>
    </ModalProvider>
    <ToastContainer position="bottom-center" autoClose={3000} closeOnClick transition={Slide} limit={3} />
  </QueryParamProvider>
);

export default AppRoot;
